<template>
  <v-card class="px-5 px-md-13 px-sm-7 px-lg-16 py-5 py-md-8 py-sm-5 py-lg-10">
    <v-row>
      <v-col cols="12">
        <header-medium :text="$t('Authenticate.Title')" />
      </v-col>
    </v-row>
    <v-card-text>
      <v-row>
        <v-col cols="12">
          <p v-text="$t('RevokePage.sms_authenticate')" class="text-center mb-0"></p>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="12" sm="5" md="5">
          <v-otp-input v-model="otp" @finish="focusSubmit" :label="$t('Authenticate.EnterCode')" type="number"></v-otp-input>
        </v-col>
      </v-row>
      <!--<v-row justify="center">
                <v-col cols="12" sm="5" md="5">
                  <p class="text-center ma-0 pa-0 caption">
                    <a class="text-decoration-none" @click="retrySMS">{{
                      $t("Authenticate.NotReceivedCodeLink")
                    }}</a>
                  </p>
                </v-col>
              </v-row>-->
    </v-card-text>
    <v-row justify="center">
      <v-col cols="12" class="text-right">
        <custom-button id="submit" :text="$t('Navigation.next')" @click="checkSMS"></custom-button>
      </v-col>
    </v-row>
  </v-card>
</template>
<script>
import HeaderMedium from "../../components/ui/text/HeaderMedium.vue";
import CustomButton from "../../components/ui/input/CustomButton.vue";
import { log } from "@/helpers/logger";

export default {
  name: "authorize",
  components: {
    HeaderMedium,
    CustomButton,
  },
  props: {
    ips_id: String,
    type: String,
    email: String
  },
  data() {
    return {
      otp: "",
      showPassword: false,
      rules: {
        password: [(v) => !!v || this.$t("required")],
      },
      password: "",
    };
  },
  methods: {
    focusSubmit() {
     
      document.getElementById("submit").focus();
    }, 
    retrySMS() {
      var signer = {
        workflow_id: this.workflow.workflow_id,
        signer_id: this.workflow.signer_id,
        first_name: this.workflow.first_name,
        last_name: this.workflow.last_name,
        phone: this.workflow.phone,
        email: this.workflow.email,
      };

      this.$store.dispatch("data/retrySMS", signer).then(() => { });
    },
    async checkSMS() {
      this.$store
        .dispatch("data/checkRevokeSMS", {
          otp: this.otp,
          id: this.ips_id,
        })
        .then((resp) => {
          log(
            "RevokePage.Authorize.checkSMS() - checked OTP for signer " +
            this.signer_id,
            "info"
          );
          if (resp) {
            this.$emit("authorized", true);
          }
        })
        .catch((err) => {
          this.otp = "";
          log("RevokePage.Authorize.checkSMS() - " + err, "error");
        });
    },
  },
};
</script>

<style scoped>
/*Removes Number Spin Buttons*/
.code>>>input[type="number"] {
  -moz-appearance: textfield;
}

.code>>>input::-webkit-outer-spin-button,
.code>>>input::-webkit-inner-spin-button {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}
</style>
